import * as React from 'react';

function ExcelTemplateIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} width={69} height={76} viewBox="0 0 69 76" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_12049_67972)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.4154 0.329162C15.1049 0.63965 15.0767 2.9529 15.1267 24.0283C15.1792 46.2925 15.2 47.3947 15.5746 47.6242C15.889 47.817 16.0295 47.7809 16.2802 47.4435C16.548 47.0827 16.5931 43.7428 16.5931 24.2654V1.5088H26.7565C35.2674 1.5088 36.9883 1.45799 37.3414 1.19592C37.6788 0.945361 37.7148 0.804665 37.522 0.490268C37.2958 0.121156 36.6337 0.0940156 26.5205 0.0412543C16.9392 -0.00890159 15.722 0.0225816 15.4154 0.329162ZM44.0051 0.132663C43.5887 0.300718 43.6829 1.03221 44.1536 1.28408C44.3931 1.41218 46.0726 1.5088 48.0619 1.5088H51.5502V6.7122C51.5502 11.6344 51.573 11.9278 51.9701 12.1403C52.2263 12.2773 54.4286 12.365 57.6154 12.365H62.8407V39.3971V66.4291H39.7169H16.5931V59.9332C16.5931 56.3604 16.5338 53.2827 16.4613 53.0938C16.2904 52.6484 15.3759 52.6484 15.205 53.0938C15.1325 53.2827 15.0732 56.5489 15.0732 60.3518C15.0732 66.3486 15.1186 67.312 15.4143 67.6079C15.7205 67.9138 18.2111 67.949 39.5823 67.949C58.3024 67.949 63.4882 67.8908 63.7778 67.6776C64.1222 67.4242 64.143 65.5051 64.0909 38.8604L64.0349 10.3145L58.2811 5.15737L52.5273 0L48.4019 0.0117249C46.133 0.0180215 44.1545 0.0725197 44.0051 0.132663ZM57.7454 6.52916C60.309 8.81266 62.4065 10.7179 62.4065 10.7631C62.4065 10.8083 60.2569 10.8452 57.6297 10.8452H52.853V6.61123C52.853 4.28257 52.9051 2.3773 52.9687 2.3773C53.0325 2.3773 55.1821 4.24566 57.7454 6.52916Z"
          fill="currentColor"
        />
        <rect x="52.2021" y="26.0547" width="7.16512" height="4.77675" fill="currentColor" />
        <rect x="42.6484" y="26.0547" width="7.16512" height="4.77675" fill="currentColor" />
        <rect x="52.2021" y="33.2188" width="7.16512" height="4.77675" fill="currentColor" />
        <rect x="42.6484" y="33.2188" width="7.16512" height="4.77675" fill="currentColor" />
        <rect x="52.2021" y="40.3867" width="7.16512" height="4.77675" fill="currentColor" />
        <rect x="42.6484" y="40.3867" width="7.16512" height="4.77675" fill="currentColor" />
        <rect x="4" y="17.1523" width="36.6941" height="36.6941" rx="10" fill="currentColor" />
        <path
          d="M17.9657 26.7031L22.2273 32.7313L26.4225 26.7031H30.1417L24.0869 35.293L30.7062 44.5074H26.9206L22.2273 37.8547L17.534 44.5074H13.7705L20.3234 35.293L14.2022 26.7031H17.9657Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_12049_67972"
          x="0"
          y="0"
          width="68.1123"
          height="75.9492"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12049_67972" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_12049_67972" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

const MemoExcelTemplateIcon = React.memo(ExcelTemplateIcon);
export default MemoExcelTemplateIcon;
